<template>
  <container>
    <row class="mt-5 align-items-center justify-content-start">
      <h4 style="margin: 0" class="grey-text"><strong>Select</strong></h4>
      <a href="https://mdbootstrap.com/vue/advanced/select/?utm_source=DemoApp&utm_medium=MDBVuePro" waves-fixed class="border grey-text px-2 border-light rounded ml-2" target="_blank"><fa icon="graduation-cap" class="mr-2"/>Docs</a>
    </row>
    <hr />
    <container class="mt-5">
      <h4 class="pb-3">Basic example</h4>
      <row>
        <column sm="6">
          <mdb-select @getValue="getSelectValue">
            <option disabled selected>Choose your option</option>
            <option value="Option 1">Option nr 1</option>
            <option value="Option 2">Option nr 2</option>
            <option value="Option 3">Option nr 3</option>
            <option value="Option 4">Option nr 4</option>
            <option value="Option 5">Option nr 5</option>
          </mdb-select>
          <label>Example label</label>
        </column>
      </row>
      <h4 class="pt-4 pb-3">Color variations</h4>
      <row>
        <column sm="6">
          <mdb-select color="primary" @getValue="getSelectValue">
            <option disabled selected>Choose your option</option>
            <option value="Option 1">Option nr 1</option>
            <option value="Option 2">Option nr 2</option>
            <option value="Option 3">Option nr 3</option>
            <option value="Option 4">Option nr 4</option>
            <option value="Option 5">Option nr 5</option>
          </mdb-select>
          <label>Example label</label>
        </column>
      </row>
      <h4 class="pt-4 pb-3">Multiple select</h4>
      <row>
        <column sm="6">
          <mdb-select multiple search @getValue="getSelectValue">
            <option disabled selected>Choose your option</option>
            <option value="Option 1">Option nr 1</option>
            <option value="Option 2">Option nr 2</option>
            <option value="Option 3">Option nr 3</option>
            <option value="Option 4">Option nr 4</option>
            <option value="Option 5">Option nr 5</option>
          </mdb-select>
          <label>Example label</label>
        </column>
      </row>
      <h4 class="pt-4 pb-2">Options groups</h4>
      <row>
        <column sm="6">
          <mdb-select @getValue="getSelectValue">
            <option disabled>team 1</option>
            <option value="Option 1">Option nr 1</option>
            <option value="Option 2">Option nr 2</option>
            <option disabled>team 2</option>
            <option value="Option 3">Option nr 3</option>
            <option value="Option 4">Option nr 4</option>
          </mdb-select>
          <label>Example label</label>
        </column>
      </row>
      <h4 class="pt-4 pb-2">Select with icons</h4>
      <row>
        <column sm="6">
          <mdb-select @getValue="getSelectValue">
            <option icon disabled>Choose your option</option>
            <option icon="https://mdbootstrap.com/img/Photos/Avatars/avatar-1.jpg" value="Option 1">Option nr 1</option>
            <option icon="https://mdbootstrap.com/img/Photos/Avatars/avatar-2.jpg" value="Option 2">Option nr 2</option>
            <option icon="https://mdbootstrap.com/img/Photos/Avatars/avatar-3.jpg" value="Option 3">Option nr 3</option>
          </mdb-select>
          <label>Example label</label>
        </column>
      </row>
      <h4 class="pt-4 pb-2">Disabled select</h4>
      <row>
        <column sm="6">
          <mdb-select disabled>
            <option value="Option 1">Option nr 1</option>
            <option value="Option 2">Option nr 2</option>
            <option value="Option 3">Option nr 3</option>
            <option value="Option 4">Option nr 4</option>
          </mdb-select>
          <label>Example label</label>
        </column>
      </row>
      <br><br><br><br><br><br><br><br><br>
    </container>
  </container>
</template>

<script>
import { Container, Row, Column, mdbSelect, Fa } from 'mdbvue';

export default {
  name: 'SelectPage',
  components: {
    Container,
    Row,
    Column,
    mdbSelect,
    Fa
  },
  methods: {
    getSelectValue(value) {
      console.log(value);
    }
  }
};
</script>

<style scoped>
</style>
